import { render, staticRenderFns } from "./ServicesReservationAddClient.vue?vue&type=template&id=39f038b8&scoped=true&"
import script from "./ServicesReservationAddClient.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f038b8",
  null
  
)

export default component.exports